import ApproversList from '../Distribution/ApproversList'
import { LuxInputSwitch, LuxIcon } from '@lux/wardrobe-lib'
import { DistributionForm } from '@/app/models/new-activity-form'
import { Approver, TaskSubType } from '@/app/models/task'
import { useEffect, useState } from 'react'
import { ProjectsService } from '@/app/services/ProjectsService'
import { useIntl } from 'react-intl'

export const DistributionApprovers = (props: {
    taskSubType?: TaskSubType
    onChangeForm: (distForm: DistributionForm) => void
    form: DistributionForm
    selectedRecipients: string[]
}) => {
    const componentClass = 'smart-new-activity-distribution'
    const { form, taskSubType, onChangeForm, selectedRecipients } = props
    const intl = useIntl()

    const [loading, setLoading] = useState(false)
    const [approversList, setApproversList] = useState<Approver[]>([])

    const selectApprovers = (list: Approver[]) => {
        let _approversRoleList = []
        list.forEach((a) => {
            if (a.selected) _approversRoleList.push(a.role)
        })
        onChangeForm({ ...form, approversList: _approversRoleList })
    }

    useEffect(() => {
        if (taskSubType) {
            setLoading(true)
            ProjectsService.GetApproversList(taskSubType)
                .then((res) => {
                    if (res.data?.roleApprovers) {
                        setApproversList(
                            res.data?.roleApprovers.map((a) => ({
                                ...a,
                                selected: form?.approversList?.includes(a.role),
                            }))
                        )
                    }
                })
                .catch((e) => console.error(e))
                .finally(() => setLoading(false))
        }
    }, [taskSubType])

    useEffect(() => {
        if (approversList?.length) selectApprovers(approversList)
    }, [approversList])

    useEffect(() => {
        if (selectedRecipients?.length === 0)
            onChangeForm({
                ...form,
                approversList: [],
                approvalRequired: false,
            })
    }, [selectedRecipients])

    return (
        <>
            <div className={`${componentClass}__approver-switch`}>
                {taskSubType !== TaskSubType.SERVICE_REQUEST && (
                    <LuxInputSwitch
                        label={intl.formatMessage({
                            id: 'ph2.modals.new.activity.creation.distribution.approval_required',
                            defaultMessage: 'Approval required',
                        })}
                        additionalProps={{ disabled: !selectedRecipients?.length }}
                        value={form.approvalRequired}
                        onChangeCallback={(val: boolean) => {
                            onChangeForm({
                                ...form,
                                approversList: val ? form.approversList : [],
                                // clear selected approvers if approval is not required
                                approvalRequired: val,
                            })
                        }}
                    />
                )}
                {(!selectedRecipients ||
                    selectedRecipients?.length === 0 ||
                    selectedRecipients?.includes('regionalmanager')) && (
                    <div className="flex mt-2">
                        <LuxIcon icon="info" size={14} classes="mr-2" />
                        <div className="text-mini">
                            {selectedRecipients?.includes('regionalmanager')
                                ? intl.formatMessage({
                                      id: 'modals.new.activity.approval.photographic.recipient.regman_disclaimer',
                                      defaultMessage:
                                          'Attention! The regional manager profile cannot be selected as both a recipient and an approver.',
                                  })
                                : intl.formatMessage({
                                      id: 'modals.new.activity.approval.photographic.recipient.disclaimer',
                                      defaultMessage: 'Select recipients first.',
                                  })}
                        </div>
                    </div>
                )}
            </div>
            {(form.approvalRequired || taskSubType == TaskSubType.SERVICE_REQUEST) && (
                <div className={`${componentClass}__approver-list-container`}>
                    <ApproversList
                        approversList={approversList}
                        setApproversList={setApproversList}
                        loading={loading}
                        selectedRecipients={selectedRecipients}
                        mandatory={taskSubType == TaskSubType.SERVICE_REQUEST}
                    />
                </div>
            )}
        </>
    )
}
